import { Box } from '@mui/material'
import { styled } from '@mui/system'

import Footer from './Footer'

const RootContainer = styled(Box)({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
})

const MainContent = styled(Box)({
  height: '100%',
  flexGrow: 1,
  display: 'flex',
  maxWidth: 'none',
  width: '100%',
})

interface LoginLeyoutProps {
  children: React.ReactNode
}
const LoginLayout: React.FC<LoginLeyoutProps> = ({ children }) => {
  return (
    <RootContainer>
      <MainContent>{children}</MainContent>
      <Footer />
    </RootContainer>
  )
}

export default LoginLayout
